import { combineReducers } from 'redux'
import api from './API/Api'
// import { routerReducer } from 'connected-react-router'
import { connectRouter } from 'connected-react-router'

import * as Common from './Common'
import * as Page from './Page'

const reducers = (history) => combineReducers({
  api,
  ...Common,
  ...Page,
//  routing: routerReducer,
  router: connectRouter(history)
})

export default reducers


// WEBPACK FOOTER //
// ./src/reducers/index.js